import services from '@/config/services'
import FileManager from '@/services/ask-file-manager/index.js'


export default class CreaClientiService {
  constructor(http, eventBus){
    this.http = http
    this.eventBus = eventBus
    this.praticheUrl = `${services.ask_pratiche.url}`
    this.apiUrl = `${services.ask_api.url}/management`
    this.filemanager = new FileManager()
  }
 
  async getTypeClients() {
    let items = []
    let success = false
    const url = `${this.praticheUrl}/get-tipo-cliente`

    try {
      let res = await this.http.get(url)
      items = res.data
      success = true
    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err, url })
    } finally {
      this.eventBus.emit('data-loaded')
    }

    return { items, success }
  }

  async getSpedizioni() {
    let items = []
    let success = false
    const url = `${this.praticheUrl}/get-spedizioni`

    try {
      let res = await this.http.get(url)
      items = res.data
      success = true
    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err, url })
    } finally {
      this.eventBus.emit('data-loaded')
    }

    return { items, success }
  }

  async getPagamenti() {
    let items = []
    let success = false
    const url = `${this.praticheUrl}/get-pagamenti`

    try {
      let res = await this.http.get(url)
      items = res.data
      success = true
    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err, url })
    } finally {
      this.eventBus.emit('data-loaded')
    }

    return { items, success }
  }

  async getIvas() {
    let items = []
    let success = false
    const url = `${this.praticheUrl}/get-ivas`

    try {
      let res = await this.http.get(url)
      items = res.data
      success = true
    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err, url })
    } finally {
      this.eventBus.emit('data-loaded')
    }

    return { items, success }
  }

  async getScadenze() {
    let items = []
    let success = false
    const url = `${this.praticheUrl}/get-scadenze`

    try {
      let res = await this.http.get(url)
      items = res.data
      success = true
    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err, url })
    } finally {
      this.eventBus.emit('data-loaded')
    }

    return { items, success }
  }

  async getOfferte() {
    let items = []
    let success = false
    const url = `${this.praticheUrl}/get-offerte`

    try {
      let res = await this.http.get(url)
      items = res.data
      success = true
    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err, url })
    } finally {
      this.eventBus.emit('data-loaded')
    }

    return { items, success }
  }


  async getFatturazioni() {
    let items = []
    let success = false
    const url = `${this.praticheUrl}/get-fatturazioni`

    try {
      let res = await this.http.get(url)
      items = res.data
      success = true
    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err, url })
    } finally {
      this.eventBus.emit('data-loaded')
    }

    return { items, success }
  }


  async getPeriodi() {
    let items = []
    let success = false
    const url = `${this.praticheUrl}/get-periodi`

    try {
      let res = await this.http.get(url)
      items = res.data
      success = true
    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err, url })
    } finally {
      this.eventBus.emit('data-loaded')
    }

    return { items, success }
  }


  async getAcquisizioni() {
    let items = []
    let success = false
    const url = `${this.praticheUrl}/get-acquisizioni`

    try {
      let res = await this.http.get(url)
      items = res.data
      success = true
    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err, url })
    } finally {
      this.eventBus.emit('data-loaded')
    }

    return { items, success }
  }

  async getStati() {
    let items = []
    let success = false
    const url = `${this.praticheUrl}/get-stati`

    try {
      let res = await this.http.get(url)
      items = res.data
      success = true
    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err, url })
    } finally {
      this.eventBus.emit('data-loaded')
    }

    return { items, success }
  }

  async getAgenti() {
    let items = []
    let success = false
    const url = `${this.praticheUrl}/get-agenti`

    try {
      let res = await this.http.get(url)
      items = res.data
      success = true
    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err, url })
    } finally {
      this.eventBus.emit('data-loaded')
    }

    return { items, success }
  }

  async getTipiCtr() {
    let items = []
    let success = false
    const url = `${this.praticheUrl}/get-tipi-ctr`

    try {
      let res = await this.http.get(url)
      items = res.data
      success = true
    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err, url })
    } finally {
      this.eventBus.emit('data-loaded')
    }

    return { items, success }
  }

  
  async getSDI(){
    let items = {}
    const url = `${this.praticheUrl}/get-sdi`
    try {
        let res = await this.http.get(url)
        items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        }
    }
  }

  async getToponimi(){
    let items = {}
    const url = `${this.praticheUrl}/get-toponimi`

    try {
        let res = await this.http.get(url)
        items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        }
    }

  }

  async getDistricts(value = null){
    let items = {}
    const url = `${this.praticheUrl}/get-districts/${value}`

    try {
        let res = await this.http.get(url)
        items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        }
    }

  }


  async getCities(value = null){
    let items = {}
    const url = `${this.praticheUrl}/get-cities/${value}`

    try {
        let res = await this.http.get(url)
        items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        }
    }
  }

  async validateClient(payload) {
    const url = `${this.apiUrl}/AreaFlussi/caricamento-flows/validateClient`;
  
    try {
      const response = await this.http.post(url, payload);
      return response.data; 
    } catch (err) {
      if (err.response && err.response.data) {
        return err.response.data;
      }
      throw new Error(err.message);
    }
  }

  async getRappresentanti(){
    let items = {}
    const url = `${this.praticheUrl}/get-rappresentanti`

    try {
        let res = await this.http.get(url)
        items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        }
    }

  }


  async saveClient(fd) {
    let success = false;
    let item = [];
    const url = `${this.praticheUrl}/clients/create`;
    
    try {
      let res = await this.http.post(url, fd);
  
      this.eventBus.emit("data-load-success", { message: res.data.message });
      success = true;
      item = res.data.item;
    } catch (err) {
      this.eventBus.emit("data-load-error", { message: err.message, url });
      console.error("Errore durante la chiamata API saveClient:", err);
      success = false;
    } finally {
      this.eventBus.emit("data-loaded");
    }
  
    return {
      success: success,
      item: item,
    };
  }


  async saveRepresentative(fd) {
    let success = false;
    let item = [];
    const url = `${this.praticheUrl}/representatives/create`;

    try {
        let res = await this.http.post(url, fd);

        this.eventBus.emit("data-load-success", { message: res.data.message });
        success = true;
        item = res.data.item;
    } catch (err) {
        this.eventBus.emit("data-load-error", { message: err.message, url });
        console.error("Errore durante la chiamata API saveRepresentative:", err);
        success = false;
    } finally {
        this.eventBus.emit("data-loaded");
    }

    return {
        success: success,
        item: item,
    };
}


  async associateRepresentative(payload) {
    let success = false;
    let item = [];
    const url = `${this.praticheUrl}/representatives/associate-client`;
    const settings = { headers: { 'content-type': 'application/json' } };

    try {
        let res = await this.http.post(url, payload, settings);

        this.eventBus.emit('data-load-success', { message: res.data.message });

        success = true;
        item = res.data.item;
    } catch (err) {
        this.eventBus.emit('data-load-error', { message: err.message, url });
        console.error("Errore durante la chiamata API associateRepresentative:", err);
        success = false;
    } finally {
        this.eventBus.emit('data-loaded');
    }

    return {
        success: success,
        item: item,
    };
}


}
